'use strict';

export let ValueProcessorTarget = /*#__PURE__*/function (ValueProcessorTarget) {
  ValueProcessorTarget["CSS"] = "css";
  ValueProcessorTarget["Default"] = "default";
  return ValueProcessorTarget;
}({});
//# sourceMappingURL=config.js.map